module.exports = __webpack_public_path__ + "img/Weapon_193.169cabcd.png";